<template>
<div class="MMyCourse">
    <MyCourseList></MyCourseList>
    <!--<van-tabs sticky v-model="active" animated line-height="2" line-width="25" color="#409EFF" title-inactive-color="#333" title-active-color="#409EFF">-->
        <!--<van-tab title="课程">-->
            <!--<MyCourseList></MyCourseList>-->
        <!--</van-tab>-->
        <!--<van-tab title="题库">-->
            <!--<MMyQuestion></MMyQuestion>-->
        <!--</van-tab>-->
    <!--</van-tabs>-->
</div>
</template>

<script>
import MyCourseList from 'views/mobile/my/course/components/MyCourseList'
// import MMyQuestion from 'views/mobile/my/course/components/MMyQuestion'
export default {
    name: 'MMyCourse',
    data() {
        return {
            active: 0,
        }
    },
    mounted() {},
    activated() {},
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {
        MyCourseList
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
// @import "~common/scss/variable";
.MMyCourse {
    .van-tabs__wrap {
        border-bottom: 0.01rem solid #E5E5E5;
    }
    .van-tabs__nav--line {
        padding-bottom: 0.16rem;
    }
}
</style>